import { ClassEnum, COLOR_SCHEME_OPTIONS, SETTING_TYPE } from '@/constants/enum';
import { isEmpty, PREVIEW_LOCATIONS } from '@/helpers';
import { widgetTextDetailSelector } from '@/redux/slice/widgetText.slice';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import PickupLocationItem from './PickupLocationItem';
import { widgetSettingSelector } from '@/redux/slice/widget.slice';
import { IDetailLocationInfor } from '@/types/components/location';

interface Props {
  listLocations?: (IDetailLocationInfor | undefined)[];
}

const Pickup = ({ listLocations }: Props) => {
  const widgetTextDetail = useSelector(widgetTextDetailSelector);
  const widgetSettings = useSelector(widgetSettingSelector);

  const listPickupLocation = listLocations
    ?.filter((item) => item?.isEnablePickup)
    .map((item) => {
      const addressParts = [
        item?.address?.address1,
        item?.address?.city,
        item?.address?.province,
        item?.address?.postalCode,
        item?.address?.country,
      ].filter((part) => !isEmpty(part));

      return {
        value: String(item?.id),
        label: item?.name,
        address: addressParts.join(', '),
        position: item?.position,
      };
    });

  const [locationId, setLocationId] = useState<string | undefined>(undefined);

  const widgetPickupTexts = useMemo(
    () => widgetTextDetail.texts?.find((item) => item.type === SETTING_TYPE.PICKUP),
    [widgetTextDetail.texts],
  );

  const shouldShowPickup = useMemo(
    () =>
      (listPickupLocation?.length ?? 0) > 1 ||
      ((listPickupLocation?.length ?? 0) === 1 && !widgetSettings.widgetMethods.hidePickupLocation),
    [listPickupLocation?.length, widgetSettings.widgetMethods.hidePickupLocation],
  );

  useEffect(() => {
    const sorted = [...(listPickupLocation || PREVIEW_LOCATIONS)].sort((a, b) => (a?.position || 0) - (b?.position || 0));
    const defaultId = sorted?.[0]?.value;

    if (defaultId) setLocationId(defaultId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(listPickupLocation)]);

  return (
    <div className={ClassEnum.Pickup}>
      {shouldShowPickup && (
        <>
          <label
            className={ClassEnum.PickupLabel}
            style={{ color: widgetSettings.colorScheme === COLOR_SCHEME_OPTIONS.DARK ? '#ffffff' : '#1a1a1a' }}
          >
            {widgetPickupTexts?.labelAndButtons?.instructions}
          </label>
          <div
            className={ClassEnum.PickupLocationList}
            style={{
              scrollbarColor: widgetSettings.colorScheme === COLOR_SCHEME_OPTIONS.DARK ? '#666 #1a1a1a' : '#e5e5e5 white',
            }}
          >
            {(listPickupLocation || PREVIEW_LOCATIONS)
              .sort((a, b) => (a?.position || 0) - (b?.position || 0))
              .map((item, index) => (
                <PickupLocationItem key={index} location={item} locationId={locationId} setLocationId={setLocationId} />
              ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Pickup;
